import 'css-chunksrc/client/pages/occupancyPage/toolbar/yearNavigation/years/styles.scss';export default {
  "calendar": "_calendar_1y6m5_1",
  "heading": "_heading_1y6m5_7",
  "title": "_title_1y6m5_18",
  "iconBox": "_iconBox_1y6m5_27",
  "icon": "_icon_1y6m5_27",
  "rightIcon": "_rightIcon_1y6m5_48",
  "leftIcon": "_leftIcon_1y6m5_52",
  "main": "_main_1y6m5_56",
  "years": "_years_1y6m5_60",
  "row": "_row_1y6m5_65",
  "year": "_year_1y6m5_60",
  "selected": "_selected_1y6m5_92"
};